import PageBanner from 'components/banners/PageBanner';
import Features from 'components/Features';

import React from 'react';
import { Col, Container, Image, Row } from 'react-bootstrap';
import teamWorkImage from 'assets/images/victim-support.jpeg';
import styles from './programs.module.scss';
import { Helmet } from 'react-helmet';
import RequestDemoButton from 'components/RequestDemoButton';
import { SampleReport } from './SampleReport';
import { ReactComponent as VideoPlay } from 'assets/icons/play-btn.svg';

const REPORT_DATA = [
  {
    title: '',
    items: [
      'Quarterly & Annual VOCA Report',
      'VAWA – STOP Report',
      'FVPSA',
      'Customizable Demographics',
      'Offender & Victim Linking',
      'Service Details and Summary Reports',
      'Volunteer Analytics',
    ],
  },
  {
    title: '',
    items: [
      'Hotline/Crisis Line Calls',
      'Safety Assessment Progress',
      'Follow-up and Referral Reports',
      'Case Load Detail Reports',
      'Inventory Management',
      'Outreach Activity Achievements',
    ],
  },
];
const REPORT_DATA2 = [
  {
    title: 'CENTRALIZED INTAKE   ',
    items: [
      'Family Relationship Linking',
      'Multi-Shelter and Program Tracking',
      'Non-Residential Client Intake',
      'Allows Your Agency to Keep All Your Details in One Centralized System',
    ],
  },
  {
    title: 'UNDUPLICATED CLIENT COUNT CASE MANAGEMENT',
    items: [
      'Case Notes',
      'Goals/Outcomes',
      'Self-Sufficiency Assessment',
      'Incident Report',
      'Advocacy Records',
      'Sexual Assault Records',
      'Batterer Program Records',
      'Protection Order Tracking',
      'Departure',
    ],
  },
];
const FEATURE_DATA = [
  {
    id: '01',
    title: 'Victim Services        ',
  },
  {
    id: '02',
    title: 'Security',
  },
  {
    id: '03',
    title: '    Shelter Tracking',
  },
  {
    id: '04',
    title: '    Outreach Management',
  },
  {
    id: '05',
    title: '    Referrals Management',
  },
  {
    id: '06',
    title: '    Case Management',
  },
  {
    id: '07',
    title: 'Hotline Intake    ',
  },
  {
    id: '08',
    title: 'Volunteer Tracking    ',
  },
];
function VictimSupport() {
  return (
    <div>
      <Helmet>
        <title>Victim Service Solution - CAP60</title>
        <meta
          name="description"
          content="CAP60 offers fully customizable and secure web-based Victim Services program software. Contact us Now!."
        />
        <meta name="keywords" content="victim support" />
      </Helmet>
      <PageBanner
        title="Victim Services Solution"
        subtitle="Secure and Customizable Victim Services Program Management"
      />
      <Container className="mt-4">
        <a
          href="https://www.canva.com/design/DAE9VQ_C62E/oFxCOuVRVxglCYaIlAephQ/watch?utm_content=DAE9VQ_C62E&utm_campaign=designshare&utm_medium=link&utm_source=homepage_design_menu"
          target="_blank"
          rel="noopener noreferrer"
        >
          <div className={styles.victimVideo}>
            <span>
              <VideoPlay width={100} height={100} />
            </span>
            <img src="/images/video-cover.png" alt="Victim Support" />
          </div>
        </a>
      </Container>
      <div className="floralbg-white">
        <Container className="overflow-auto">
          <CommunityServices />
        </Container>
      </div>
      <SampleReport data={REPORT_DATA} title="Reports" className="pb-0" />
      <SampleReport data={REPORT_DATA2} className="pt-5" />
      <div className="floralbg-white">
        <Container className="overflow-auto">
          <Features
            data={FEATURE_DATA}
            variant="primary"
            title="Features"
            subtitle="Dig in to know what make CAP60 Solutions unique and useful."
          />
        </Container>
      </div>
    </div>
  );
}
//
function CommunityServices() {
  return (
    <div className={styles.communityServicesWrap}>
      <Row className="align-items-center">
        <Col md="5">
          <Image src={teamWorkImage} fluid className="p-3 mb-4 mb-md-0" />
        </Col>
        <Col md="7">
          <div className="heading">
            <h2>Secure and Customizable Victim Services Program Management</h2>
          </div>
          <p>
            CAP60 offers fully customizable and secure web-based Victim Services
            program software. We understand that agencies take great care to
            protect the confidentiality and security of their clients. As your
            software provider, CAP60 provides a VAWA compliant system which
            entails tight security features, such as: Encrypting data during
            transfer and storage; Access Controls to protect client information
            and limit access to it to only those who need it; and a Program
            Sensitivity setting for further information protection, limiting the
            ability to see a program, its participants and their information to
            only those you have given permission to.
          </p>
          <p>
            CAP60 offers a centralized intake process providing you with an
            unduplicated client count while still giving you the ability to
            enter clients into the system anonymously. We can help to streamline
            your case management with built in, customizable, surveys and
            assessments as well as volunteer and referral tracking. CAP60 can
            also help simplify your reporting with our advanced reporting
            module.
          </p>
          <RequestDemoButton />
        </Col>
      </Row>
    </div>
  );
}

export default VictimSupport;
